import cn from 'classnames';

import styles from './Hint.module.scss';

interface IHintProps {
  text: string;
  variant?: 'alert' | 'warning';
  margin?: 'bottom' | 'top';
}

// Использовать для вывода подсказок желтого цвета
export const Hint = ({ text, variant = 'warning', margin }: IHintProps) => {
  return (
    <span
      className={cn(styles.container, styles[variant], {
        [styles.marginBottom]: margin === 'bottom',
        [styles.marginTop]: margin === 'top',
      })}
    >
      {text}
    </span>
  );
};
